// 产品页假变体
const productVariantBtns = document.querySelectorAll(".product-variant-btn");
productVariantBtns.forEach(function (productVariantBtn) {
  productVariantBtn.setAttribute("role", "tablist");
  const variantItem = productVariantBtn?.querySelectorAll(".item");
  variantItem?.forEach(function (item) {
    item.setAttribute("role", "tab");
    if (item.classList.contains("active")) {
      item.setAttribute("aria-selected", "true");
    }
  })
})

document.addEventListener('DOMContentLoaded', () => {
  const skipLinks = document.querySelectorAll('.skip-link');
  skipLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.querySelector(e.currentTarget.hash);
      if (!target) return;
      const hadTabindex = target.hasAttribute('tabindex');
      if (!hadTabindex) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      target.scrollIntoView({ block: 'start' });
      if (!hadTabindex) {
        target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
      }
    });
  });

  document.querySelectorAll('.site-nav--has-dropdown').forEach((item) => {
    const trigger = item.querySelector(':scope > .site-nav__link--has-dropdown');
    if (!trigger) return;
    item.addEventListener('focusin', () => trigger.setAttribute('aria-expanded', 'true'));
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) trigger.setAttribute('aria-expanded', 'false');
    });
  });
});


function announcementAccessFun() {
  document.addEventListener('DOMContentLoaded', function () {
    const announcement = document.getElementById('accessibility-announcement');
    // 创建一个函数来发布声明
    function announceAccessibilityStatement() {
      // 将声明的内容复制到屏幕可见区域
      const visibleAnnouncement = document.createElement('div');
      visibleAnnouncement.style.position = 'absolute';
      visibleAnnouncement.style.top = '0';
      visibleAnnouncement.style.left = '0';
      visibleAnnouncement.style.width = '1px';
      visibleAnnouncement.style.height = '1px';
      visibleAnnouncement.style.overflow = 'hidden';
      visibleAnnouncement.innerHTML = announcement.innerHTML;
      document.body.appendChild(visibleAnnouncement);
      // 移除声明内容（可选）
      setTimeout(() => {
        document.body.removeChild(visibleAnnouncement);
      }, 5000); // 保留一段时间以确保屏幕阅读器能够读取
    }

    // 调用函数发布声明
    announceAccessibilityStatement();
  });
}

function setfocusableAccessibility() {
  const lastFocusableElements = document.querySelectorAll('.last-focusable-element');
  lastFocusableElements.forEach(lastFocusableElement => {
    lastFocusableElement.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        e.preventDefault();
        e.stopPropagation();
        const firstFocusableElement = lastFocusableElement.parentElement.querySelector('.first-focusable-element');
        if (firstFocusableElement) {
          firstFocusableElement.focus();
        } else {
          console.warn('no .first-focusable-element');
        }
      }
    });
  });

  const firstFocusableElements = document.querySelectorAll('.first-focusable-element');
  firstFocusableElements.forEach(firstFocusableElement => {
    firstFocusableElement.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.stopPropagation();
        firstFocusableElement.click();
      }
    });
  });
}

function toggleVideo(videoId) {
  const video = document.getElementById(videoId);
  if (video) {
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }
}
announcementAccessFun();
setfocusableAccessibility();
toggleVideo();
